import { VENDOR_OFFERING_TAGS } from "../../../../config/appData";
import FormField from "../../register/components/FormField";
import { AmenitiesChipInput } from "../BusinessCompletionProfile/AmenitiesChipInput";


function Step3VenueDescription({ formData, errors, handleChange, readOnly = false, isVendor = false }) {
  const vendorType = formData?.vendor_type ?? "";
  const offeringSuggestions = isVendor && vendorType ? (VENDOR_OFFERING_TAGS[vendorType] || []) : null;
  const amenitiesLabel = isVendor ? "Offerings" : "Amenities";

  return (
    <div className="step3-form step1-form">
      <FormField
        label="Description"
        name="description"
        type="textarea"
        value={formData.description}
        onChange={handleChange}
        error={errors.description}
        placeholder={isVendor ? "e.g. Describe your services and experience" : "e.g. Spacious banquet hall with modern amenities"}
        required
        rows={4}
        disabled={readOnly}
        icon={
          <path
            d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"
            stroke="currentColor"
            strokeWidth="2"
            fill="none"
          />
        }
      />
      <AmenitiesChipInput
        label={amenitiesLabel}
        value={formData.amenities}
        onChange={handleChange}
        error={errors.amenities}
        placeholder="Type or pick from suggestions below"
        required
        readOnly={readOnly}
        suggestions={offeringSuggestions}
      />
    </div>
  );
}

export default Step3VenueDescription;
